import { Getters } from 'vuex-smart-module';
import RepairsState from './state';

export default class RepairsGetters extends Getters<RepairsState> {}
